export default __webpack_public_path__ + "static/media/DOM-JAN2025.44b7f3dd.png";